import { uniqBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useProgramSession } from '../schedule/useProgramSession';
import { useEventSpeakers } from './useEventSpeakers';

export function useSessionSpeakers(eventId, programId) {
    const scheduleSession = useProgramSession(eventId, programId),
        sessionSpeakers = scheduleSession.speakers,
        speakersFilter = useCallback((s) => sessionSpeakers.some((sp) => sp.id == s.id), [sessionSpeakers]),
        speakers = useEventSpeakers(eventId, {
            filter: speakersFilter,
        });

    return useMemo(() => {
        // Merge speakers with session speakers by ID
        // give preference to session provided data, as may have been customized by api
        // maybe in the future we should merge the records instead of using one or the other
        let result = [...(sessionSpeakers ?? []), ...(speakers ?? [])];
        result = uniqBy(result, 'id');

        return result;
    }, [speakers, sessionSpeakers]);
}
